import {
    ADD_TO_BETSLIP,
    REMOVE_FROM_BETSLIP,
    CLEAR_BETSLIP,
    UPDATE_TO_BETSLIP,UPDATE_TO_PARLAY_BETSLIP, LOAD_BETSLIP,HIDE_BETSLIP_LOADER
} from './../../constants/actionTypes';
import {loadState, saveState} from "../../helpers/localstorage";

const INIT_STATE = {
    isLoading: false,
    betSlips: {},
    parlayBetSlips: {},
};
const STORE_KEY        = 'bet_slip';
const PARLAY_STORE_KEY = 'parlay_bet_slip';
type SlipAction = { type: string, payload: {} | string,payload_1: {} | string };
const BetSlip = (state: State = INIT_STATE, action: SlipAction) => {
    let oddToAdd = {};
    let oddToParlayAdd = {};
    let oddToAdd_1 = {};
    switch (action.type) {
        case LOAD_BETSLIP:
            return { ...state, isLoading: true };
        case HIDE_BETSLIP_LOADER:
            return { ...state, isLoading: false };
        case ADD_TO_BETSLIP:
            oddToAdd = action.payload;
            oddToAdd['stake_value'] = 0;
            oddToAdd['win_value'] = 0;
            state.betSlips[oddToAdd.id] = oddToAdd;
            saveState(STORE_KEY, state.betSlips);
            oddToParlayAdd = Object.assign({}, action.payload);
            oddToParlayAdd['stake_value'] = 0;
            oddToParlayAdd['win_value'] = 0;
            state.parlayBetSlips[oddToParlayAdd.id] = oddToParlayAdd;
            saveState(PARLAY_STORE_KEY, state.parlayBetSlips);
            return {...state, isLoading: false};
            break;
        case REMOVE_FROM_BETSLIP:
            let oddToRemove = action.payload;
            delete state.betSlips[oddToRemove.id];
            saveState(STORE_KEY, state.betSlips);
            let oddParlayToRemove = Object.assign({}, action.payload);
            delete state.parlayBetSlips[oddParlayToRemove.id];
            saveState(PARLAY_STORE_KEY, state.parlayBetSlips);
            return {...state, isLoading: false};
            break;
        case UPDATE_TO_BETSLIP:
            oddToAdd = action.payload;
            state.betSlips[oddToAdd.id] = oddToAdd;

            saveState(STORE_KEY, state.betSlips);
            return {...state, isLoading: false};
            break;
        case UPDATE_TO_PARLAY_BETSLIP:
            oddToAdd_1 = Object.assign({}, action.payload);
            state.parlayBetSlips[oddToAdd_1.id] = oddToAdd_1;
            saveState(PARLAY_STORE_KEY, state.parlayBetSlips);
            return {...state, isLoading: false};
            break;
        case CLEAR_BETSLIP:
            state.betSlips = {};
            state.parlayBetSlips = {};
            saveState(STORE_KEY, state.betSlips);
            saveState(PARLAY_STORE_KEY, state.parlayBetSlips);
            return {...state, betSlips: {}, parlayBetSlips: {}, isLoading: false};
            break;
        default:
            //check if exist to local storage
            let betslip = loadState(STORE_KEY);
            if (betslip !== null) {
                state.betSlips = betslip;
            }
            let parlayBetSlip = loadState(PARLAY_STORE_KEY);
            if (parlayBetSlip !== null) {
                state.parlayBetSlips = parlayBetSlip;
            }
            return {...state, isLoading: false};
    }
}
export default BetSlip;
